import React, { Component, PropTypes } from "react";
import AppPage from "components/AppPage";
import FullScreenDialog from "components/FullScreenDialog";
import CoursioLogo from "components/CoursioLogo";
import { history } from "helpers";

const styles = {
    root: {
        margin: `2em 3em`,
        textAlign: "center",
    },
    warning: {
        fontSize: 32,
        lineHeight: "normal",
        marginTop: "1em",
    },
};

class CoursioError extends Component {
    constructor(props) {
        super(props);
    }
    static contextTypes = {
        getIntlMessage: PropTypes.func,
    };

    render() {
        return (
            <AppPage style={{ background: "#00c9cc" }}>
                <FullScreenDialog open toolbar={false} overlay={false} padded>
                    <div style={styles.root}>
                        <CoursioLogo initialFill="#00c9cc" size={100} width="48px" />
                        <div style={styles.warning}>
                            {this.context.getIntlMessage("error")}
                            <a style={{cursor: 'pointer'}} onClick={() => history.goBack()}>
                                {'\xa0'}
                                {this.context.getIntlMessage("here")}
                            </a>
                        </div>
                    </div>
                </FullScreenDialog>
            </AppPage>
        );
    }
}

export default CoursioError;



// WEBPACK FOOTER //
// ./src/js/components/Route/CoursioError.js